// This Mixin protects pages that require a user to be logged in

import router from '@/router/index.js'
import store from '@/store/index.js'

export default {
  created: function() {
    if(!this.$store.getters.getLoggedIn) {
        // Set the return url to the current path
        store.commit('setReturnUrl', this.$router.currentRoute.path)
        router.push('/Account/Login')
    }
  },
  router: router
}
